module.exports = __webpack_public_path__ + "static/media/blockchain-in-karachi.01bbb57c.mp4";